import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { determineDomain } from '../shared/utils/login-utils';
import { LoadingContainer } from '../shared/styled/shared-styled-components';
import { LOGIN_PATH } from '../shared/constants';
import LoadingCardAuth0 from '../shared/LoadingCard/LoadingCardAuth0';

export default function RedirectPage() {
  const {
    isAuthenticated, isLoading,
  } = useAuth0();

  const handleRedirect = async () => {
    const redirect = determineDomain(true);
    window.location.replace(redirect);
  };

  const redirectToLogin = () => {
    const loginRedirect = `${window.location.origin}${LOGIN_PATH}`;
    window.location.replace(loginRedirect);
  };

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      handleRedirect();
    }
    if (!isLoading && !isAuthenticated) {
      redirectToLogin();
    }
  }, [isLoading, isAuthenticated]);

  return (
    <LoadingContainer>
      <LoadingCardAuth0 />
    </LoadingContainer>
  );
}
